export const ImportIcon = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.66675 17V28.3333C5.66675 29.0848 5.96526 29.8054 6.49661 30.3368C7.02797 30.8682 7.74863 31.1667 8.50008 31.1667H25.5001C26.2515 31.1667 26.9722 30.8682 27.5036 30.3368C28.0349 29.8054 28.3334 29.0848 28.3334 28.3333V17'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.3337 16.7501L17.0003 22.4167L22.667 16.7501'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.0005 22.4167L17.0005 4.00008'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
